import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/lib/theme";
import { AuthProvider } from "@/lib/auth";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import RoutesList from "@/pages/RoutesList";
import RouteDetail from "@/pages/RouteDetail";
import Destinations from "@/pages/Destinations";
import DestinationDetail from "@/pages/DestinationDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import RideTheWholeThing from "@/pages/RideTheWholeThing";
import Journal from "@/pages/Journal";
import SignIn from "@/pages/SignIn";
import AuthCallback from "@/pages/AuthCallback";
import Passport from "@/pages/Passport";
import NotFound from "@/pages/NotFound";

// Intercept Emergent Google OAuth returns (URL contains `#session_id=...`)
// BEFORE any protected route reads /auth/me — otherwise the callback screen
// races the ProtectedRoute check and the login "sticks" as a stale not-authed.
function AppRouter() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/routes" element={<RoutesList />} />
                <Route path="/routes/:slug" element={<RouteDetail />} />
                <Route path="/destinations" element={<Destinations />} />
                <Route path="/destinations/:slug" element={<DestinationDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/ride-the-whole-thing" element={<RideTheWholeThing />} />
                <Route path="/journal" element={<Journal />} />
                <Route path="/signin" element={<SignIn />} />
                <Route path="/passport" element={<Passport />} />
                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    );
}

function App() {
    return (
        <ThemeProvider>
            <BrowserRouter>
                <AuthProvider>
                    <div className="App">
                        <AppRouter />
                        <Toaster
                            position="bottom-right"
                            toastOptions={{
                                style: {
                                    background: "var(--card-bg)",
                                    border: "1px solid var(--border-hair)",
                                    color: "var(--fg)",
                                    borderRadius: "2px",
                                    fontFamily: "Manrope, sans-serif",
                                },
                            }}
                        />
                    </div>
                </AuthProvider>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
